module.exports = __webpack_public_path__ + "static/media/CustomizationActive.284a2942.svg";